import {
	RegisterInterestMixpanelEvents,
	type RegisterInterestType,
} from '../../constants/mixpanel-events';
import type { ContentKey } from '$global/utils/contentKey';
import { track } from '$global/utils/track';

/**
 * The top of the register-interest funnel (HB-974) — the button press on an
 * artwork surface. Pure intent, with no purchase possible: exactly what a
 * purchase funnel cannot see.
 *
 * `interest_type` records which side the user pressed, matching the `i` query
 * param the button links to and the value the submitted event reports, so buy
 * and sell intent stay separable end to end.
 *
 * The content key (HB-959) carries `artist` and the `id_value`/`id_collection`
 * pair; it is spread as-is so a surface that only knows part of the key sends
 * only what it knows rather than padding the event with nulls. On a drop page
 * that pair identifies the drop config itself, so a press during a drop's wait
 * is already attributable to its drop without a separate property (HB-970).
 */
export const trackRegisterInterestClicked = ({
	interestType,
	contentKey,
}: {
	interestType: RegisterInterestType;
	contentKey?: ContentKey;
}) => {
	track(RegisterInterestMixpanelEvents.InterestClicked, {
		...contentKey,
		interest_type: interestType,
	});
};
